/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListDocumentsQueryResponse,
  ListDocumentsQueryParams,
} from '../types/ListDocuments'

function getListDocumentsUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/` as const }
  return res
}

/**
 * @description ViewSet for document operations.
 * Uses hybrid architecture:
 * - READ operations (list, quota): Uses DRF ModelViewSet with filtering/sorting ecosystem
 * - WRITE operations (create, update, replace, delete, bulk-assign-brand): Uses Use Case pattern
 * M1.4: Implements list, create, update, delete, and storage quota.
 * M1.5 (FIR-4393): Added replace endpoint for versioning with soft delete.
 * @summary List documents (paginated, filtered)
 * {@link /api/v1/documents/}
 */
export async function listDocuments(
  params?: ListDocumentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListDocumentsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListDocumentsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
